import { ApiConnector, DELETE, GET, POST } from './requestV2.service';

export default (() => {
    const API = ApiConnector('/homework');
    const APIV2 = ApiConnector('/homework', true);

    return {
        HomeworkListTeacherCalendar: async (data, query) =>
            await API(GET, '/teacher/calendar', false, query).call(false),
        getTemplatesName: async data => await APIV2(GET, `s/templates`).call(false),
        saveModification: async data => await API(POST, `/templates`).call(data),
        anull: async (data, query) => await APIV2(DELETE, `s`, false, query).call(data),
        deleteHw: async (data, query) => await API(DELETE, `/templates`, false, query).call(data),

        copyLastDay: async data => await API(POST, `/templates/copyDay`).call(data),
        copyTemplate: async data => await API(POST, `/templates/copyTemplate`).call(data),
        callAllStat: async (data, query) => await API(GET, '/timestat/student', false, query).call(false),
        notification: async (data, query) => await API(POST, `/notification`, false, query).call(data),
        copyHw: async data => await APIV2(POST, `s/teacher/copyhw`, false, false).call(data),
        copyHwOtherGroup: async data => await APIV2(POST, `s/teacher/copyhw/othergroup`, false, false).call(data),
        GetAvailibleDates: async query => await API(GET, `/student/getdaysnotactive`, false, query).call(),
        CopyStudentHw: async data => await API(POST, `/teacher/copyhw/student`, false, false).call(data),
        GetSequance: async data => await API(POST, `/getSequance`, false, false).call(data),
        GetMultStat: async query => await API(GET, `/timestat/student/mult`, false, query).call(),
        GetPointStat: async query => await API(GET, `/timestat/student/point`, false, query).call(),
        GetHwProgress: async query => await API(GET, `/timestat/student/progress`, false, query).call(),
        CopyOtherStudents: async data => await APIV2(POST, `s/teacher/copyhw/otherstudents`, false, false).call(data),
        GetStudentRelatedHW: async query => await APIV2(GET, `s/date/ihw`, false, query).call(false),
    };
})();
